$(document).on('mouseenter', '.pub__shoppable-image__dot', function() {
    // Get the aria-labelledby attribute of the hovered element
    var ariaLabelledby = $(this).attr('aria-labelledby');
    
    // Find the parent ul and remove the active class from all areas
    var $parentUl = $(this).closest('ul.pub__shoppable-image__product-list');
    $parentUl.find('.pub__shoppable-image__area').removeClass('pub__shoppable-image__area--active');
    
    // Add the active class to the parent .pub__shoppable-image__area of the hovered element
    $(this).closest('.pub__shoppable-image__area').addClass('pub__shoppable-image__area--active');
});
$(document).ready(function() {
    // Click event on .mrk-parent-item
    $('.mrk-parent-item').on('click', function(event) {
        event.preventDefault();
        $('.mrk-parent-item').removeClass('mrk-active-dropdown');
        $(this).addClass('mrk-active-dropdown');
        // Get the data-content attribute
        var contentId = $(this).attr('data-content');
        console.log(contentId);
        // Hide all .mrk-menu-dropdown-item
        $('.mrk-menu-dropdown-item').hide();

        // Show the specific dropdown item
        $('#' + contentId).show();

        // Add class to .hnf-dropdown
        $('.hnf-dropdown').addClass('hnf-list-box--open');

        // Add class to .mrk-main-menu-wrapper
        $('.mrk-main-menu-wrapper').addClass('hnf-carousel--dropdown-open');
        var mrk_offset = (window.innerWidth - 1200)/2;
        // Get the left position of the clicked element
        var leftPos = $(this).offset().left - mrk_offset;
        var total_left = leftPos + $('.hnf-dropdown').width();
        if(total_left>window.innerWidth){
            var leftPos = window.innerWidth - mrk_offset - $('.hnf-dropdown').width() - 60;
            console.log(leftPos,total_left, 'right position');
        }
        // Set the --hnf-dropdown-left CSS variable for .hnf-dropdown
        $('.hnf-dropdown').css('--hnf-dropdown-left', leftPos + 'px');
        // console.log(leftPos);
    });

    // Document click event
    $(document).on('click', function(event) {
        // Check if the clicked element is not inside .hnf-dropdown
        if (!$(event.target).closest('.hnf-dropdown').length && !$(event.target).closest('.hnf-carousel-slide').length) {
            // Remove the added classes
            $('.hnf-dropdown').removeClass('hnf-list-box--open');
            $('.mrk-main-menu-wrapper').removeClass('hnf-carousel--dropdown-open');
        }
    });
    $('.tab-btn-item').on('click', function(e) {
        e.preventDefault();

        // Remove the .mrk-tab-active class from all .tab-btn-item and add to the current one
        $('.tab-btn-item').removeClass('mrk-tab-active');
        $(this).addClass('mrk-tab-active');

        // Get the data-content attribute of the clicked button
        var contentUrl = $(this).attr('data-content');

        // Show loader content before sending the ajax request
        var loaderContent = $('#loading-content').html();
        $('.mrk-tab-inner-content').html(loaderContent);

        // Send the AJAX request to get the content
        $.ajax({
            url: contentUrl,
            method: 'GET',
            cache: true, // Enable caching in the AJAX request
            success: function(data) {
                // Insert the HTML content into .mrk-tab-inner-content
                console.log($(data).find('.mrk-data-content').html());
                $('.mrk-tab-inner-content').html($(data).find('.mrk-data-content').html());
                $('.mrk-load-more-wrapper').html($(data).find('.mrk-load-more-wrapper').html());
            },
            error: function() {
                // Handle the error case, you can display an error message if needed
                $('.mrk-tab-inner-content').html('<p>Error loading content. Please try again.</p>');
            }
        });
    });
    function updateScrollButtons(scrollBar, carousel) {
        var scrollLeft = scrollBar.scrollLeft();
        var scrollWidth = scrollBar[0].scrollWidth;
        var clientWidth = scrollBar[0].clientWidth;

        // Hide the previous button if we're at the start
        if (scrollLeft <= 0) {
            carousel.find('.mrk-prev-btn').addClass('hnf-carousel__button--hidden');
        } else {
            carousel.find('.mrk-prev-btn').removeClass('hnf-carousel__button--hidden');
        }

        // Hide the next button if we're at the end
        if (scrollLeft + clientWidth >= scrollWidth) {
            carousel.find('.mrk-next-btn').addClass('hnf-carousel__button--hidden');
        } else {
            carousel.find('.mrk-next-btn').removeClass('hnf-carousel__button--hidden');
        }
    }

    function checkIfScrollable(scrollBar, carousel) {
        var scrollWidth = scrollBar[0].scrollWidth;
        var clientWidth = scrollBar[0].clientWidth + 20;
        console.log(scrollWidth,clientWidth);
        // If the content doesn't overflow, add the mrk-no-scrolling class
        if (scrollWidth <= clientWidth) {
            carousel.addClass('mrk-no-scrolling');
        } else {
            carousel.removeClass('mrk-no-scrolling');
        }
    }

    // Handle click on the previous button
    $('.mrk-prev-btn').on('click', function(e) {
        e.preventDefault();

        // Find the parent .hnf-carousel and the .mrk-scroll-bar within it
        var carousel = $(this).closest('.hnf-carousel');
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Scroll left by a defined amount (e.g., 400px)
        var scrollAmount = 400;
        scrollBar.animate({
            scrollLeft: '-=' + scrollAmount
        }, 400, function() {
            // Update buttons after the scroll completes
            updateScrollButtons(scrollBar, carousel);
        });
    });

    // Handle click on the next button
    $('.mrk-next-btn').on('click', function(e) {
        e.preventDefault();

        // Find the parent .hnf-carousel and the .mrk-scroll-bar within it
        var carousel = $(this).closest('.hnf-carousel');
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Scroll right by a defined amount (e.g., 400px)
        var scrollAmount = 400;
        scrollBar.animate({
            scrollLeft: '+=' + scrollAmount
        }, 400, function() {
            // Update buttons after the scroll completes
            updateScrollButtons(scrollBar, carousel);
        });
    });

    // On page load, check if scrolling is possible and update the buttons
    $('.hnf-carousel').each(function() {
        var carousel = $(this);
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Check if scroll is possible and update the buttons and class
        checkIfScrollable(scrollBar, carousel);
        updateScrollButtons(scrollBar, carousel);
    });
    $(document).on('click', '.mrk-load-more', function(e) {
        e.preventDefault();

        // Get the loading template and append it to .mrk-tab-inner-content
        var loadingTemplate = $('#loading-content').html();
        $('.mrk-tab-inner-content').append(loadingTemplate);

        // Get the data-content attribute from the clicked button
        var contentUrl = $(this).attr('data-content');

        // Send the AJAX request to get the content
        $.ajax({
            url: contentUrl,
            method: 'GET',
            cache: true, // Ensure caching is enabled
            success: function(data) {
                // Remove all loading items from .mrk-tab-inner-content
                $('.mrk-tab-inner-content .loading-item').remove();

                // Append the HTML content from .mrk-data-content inside the response
                $('.mrk-tab-inner-content').append($(data).find('.mrk-data-content').html());

                // Replace the .mrk-load-more-wrapper content with the new one from the response
                $('.mrk-load-more-wrapper').html($(data).find('.mrk-load-more-wrapper').html());
            },
            error: function() {
                // Handle the error case, you can display an error message if needed
                $('.mrk-tab-inner-content').append('<p>Error loading more content. Please try again.</p>');
            }
        });
    }); 
});
